import React, { useEffect, useState } from 'react';

const Header = ({ showBackButton=true }) => {
  useEffect(() => {
    // console.log(showBackButton);
  })
  return (
    <div className="bg-gray-100">
      <div className="flex items-center text-sm pt-3 pb-3 bg-blue-200 px-4 sm:px-6">
       {showBackButton && <button
          className="ml-2 sm:ml-4 bg-blue-500 hover:bg-blue-600 text-gray-100 py-1.5 px-3 sm:py-2 sm:px-4 rounded-lg transition duration-300 ease-in-out flex items-center text-sm sm:text-base"
          onClick={() => window.history.back()}
        >
          <svg
            className="w-4 h-4 sm:w-5 sm:h-5 mr-1"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M15 19l-7-7 7-7"
            />
          </svg>
          Back
        </button>}
        <div className="flex-grow mr-2 sm:mr-4 text-center text-lg sm:text-2xl font-semibold">
          ECMR Assist Portal
        </div>
      </div>
    </div>
  );
};

export default Header;